function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component, register } from 'ovee.js';
import gsap from 'gsap';

var _class = (_dec = register('accordion-base'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      this.options = this.getOptions();
      this.items = this.$element.querySelectorAll('[data-accordion-item]');
      this.isAnimating = false;
      this.isActive = true;
      this.element = this.$element;
      this.prevHeight = 0;
      this.loadContainer = this.$element.closest('[data-load-container]');

      if (this.items) {
        this.triggers = this.element.querySelectorAll('[data-accordion-trigger]');
        this.initAttributes();
        this.calcHeights();
        this.bind();
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var firstActive = false;
      var autoCollapse = false;
      var speed = 0.5;
      var ease = 'power2.inOut';
      var height = 'calc';
      return {
        firstActive: firstActive,
        autoCollapse: autoCollapse,
        speed: speed,
        ease: ease,
        height: height
      };
    }
  }, {
    key: "getInnerHeight",
    value: function getInnerHeight(content) {
      var totalHeight = 0;
      content.querySelectorAll(':scope > *').forEach(function (item) {
        totalHeight += item.getBoundingClientRect().height;
      });
      return "".concat(totalHeight, "px");
    }
  }, {
    key: "initAttributes",
    value: function initAttributes() {
      for (var i = 0; i < this.items.length; i++) {
        var element = this.items[i];
        var trigger = element.querySelector('[data-accordion-trigger]');
        var content = element.querySelector('[data-accordion-content]');
        var timestamp = Date.now();
        var id = "accordion-".concat(timestamp + Math.floor(Math.random() * (timestamp - 0)) + 0);
        content.setAttribute('id', id);
        this.setAttributes(trigger, {
          'aria-controls': id,
          'aria-expanded': false
        });
      }
    }
  }, {
    key: "initNewItems",
    value: function initNewItems() {
      for (var i = 0; i < this.items.length; i++) {
        var element = this.items[i];
        var trigger = element.querySelector('[data-accordion-trigger]');
        var content = element.querySelector('[data-accordion-content]');

        if (!content.hasAttribute('id')) {
          var timestamp = Date.now();
          var id = "accordion-".concat(timestamp + Math.floor(Math.random() * (timestamp - 0)) + 0);
          content.setAttribute('id', id);
          this.setAttributes(trigger, {
            'aria-controls': id,
            'aria-expanded': false
          });
          this.hide(trigger, this.items[i], content, true);
        }
      }
    }
  }, {
    key: "refreshItems",
    value: function refreshItems() {
      var itemsNew = this.$element.querySelectorAll('[data-accordion-item]');
      this.items = itemsNew;

      if (this.items) {
        this.triggers = this.element.querySelectorAll('[data-accordion-trigger]');
        this.initNewItems();
        this.linkClickHandlers();
      }
    }
  }, {
    key: "setAttributes",
    value: function setAttributes(elem, attrs) {
      Object.keys(attrs).forEach(function (key) {
        elem.setAttribute(key, attrs[key]);
      });
    }
  }, {
    key: "calcHeights",
    value: function calcHeights() {
      // to be adjusted based on component
      this.hideAll();
    }
  }, {
    key: "disable",
    value: function disable() {
      this.isActive = false;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.isActive = true;
    }
  }, {
    key: "showAll",
    value: function showAll() {
      var _this = this;

      this.items.forEach(function (obj) {
        var btn = obj.querySelector('[data-accordion-trigger]');
        var content = obj.querySelector('[data-accordion-content]');

        _this.show(btn, obj, content, true);
      });
    }
  }, {
    key: "show",
    value: function show(trigger, item, content) {
      var _this2 = this;

      var imm = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (item.classList.contains('is-initial')) {
        item.classList.remove('is-initial');
        var btn = item.querySelector('[data-accordion-trigger]');
        var contenthide = item.querySelector('[data-accordion-content]');
        this.hide(btn, item, contenthide, false);
      } else if (!this.isAnimating) {
        trigger.setAttribute('aria-expanded', true);
        item.classList.add('accordion-open');

        if (imm === true) {
          content.style.height = 'auto';
          content.style.opacity = 1;
          content.style.visibility = 'visible';
          content.style.pointerEvents = 'all';
        } else {
          this.isAnimating = true;
          var contentHeight = 'auto';

          if (this.options.height === 'calc') {
            contentHeight = this.getInnerHeight(content);
          }

          if (this.$element.classList.contains('categories') && this.isMobile) {
            gsap.to(this.$element, {
              duration: this.options.speed,
              delay: -(this.options.speed - 0.15),
              ease: this.options.ease,
              height: "".concat(this.$element.scrollHeight + parseFloat(contentHeight), "px"),
              onComplete: function onComplete() {
                _this2.prevHeight = _this2.$element.style.height;
              }
            });
          }

          gsap.to(content, {
            duration: this.options.speed,
            ease: this.options.ease,
            height: contentHeight,
            autoAlpha: 1,
            clearProps: 'all',
            onComplete: function onComplete() {
              _this2.isAnimating = false;
            }
          });
        }
      }
    }
  }, {
    key: "hideAll",
    value: function hideAll() {
      var _this3 = this;

      this.items.forEach(function (obj, i) {
        var btn = obj.querySelector('[data-accordion-trigger]');
        var content = obj.querySelector('[data-accordion-content]');

        if (_this3.options.firstActive === true && i === 0) {
          _this3.show(btn, obj, content, true);
        } else if (!obj.classList.contains('is-initial')) {
          _this3.hide(btn, obj, content, true);
        }
      });
    }
  }, {
    key: "hide",
    value: function hide(trigger, item, content) {
      var _this4 = this;

      var imm = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (!this.isAnimating) {
        trigger.setAttribute('aria-expanded', false);
        item.classList.remove('accordion-open');
        content.style.pointerEvents = 'none';

        if (imm === true) {
          content.style.height = 0;
          content.style.opacity = 0;
          content.style.visibility = 'hidden';
        } else {
          this.isAnimating = true;
          var contentHeight = 'auto';

          if (this.options.height === 'calc' && this.$element.classList.contains('categories') && this.isMobile) {
            contentHeight = this.getInnerHeight(content);
            contentHeight = parseFloat(contentHeight);
            this.prevHeight = parseFloat(this.$element.style.height);
            gsap.to(this.$element, {
              duration: this.options.speed,
              delay: -(this.options.speed - 0.15),
              ease: this.options.ease,
              height: "".concat(this.prevHeight - contentHeight, "px"),
              onComplete: function onComplete() {
                _this4.prevHeight = _this4.$element.style.height;
              }
            });
          }

          gsap.to(content, {
            duration: this.options.speed,
            ease: this.options.ease,
            height: 0,
            autoAlpha: 0,
            onComplete: function onComplete() {
              _this4.isAnimating = false;
            }
          });
        }
      }
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(e) {
      var _this5 = this;

      var trigger = e.target;
      var item = trigger.closest('[data-accordion-item]');
      var content = item.querySelector('[data-accordion-content]');

      if (!trigger.hasAttribute('data-accordion-trigger')) {
        trigger = item.querySelector('[data-accordion-trigger]');
      }

      var expanded = trigger.getAttribute('aria-expanded');

      if (this.options.autoCollapse === true) {
        this.items.forEach(function (obj) {
          var button = obj.querySelector('[data-accordion-trigger]');
          var cnt = obj.querySelector('[data-accordion-content]');

          if (button.getAttribute('aria-expanded') === 'true') {
            _this5.hide(button, obj, cnt);

            _this5.isAnimating = false;
          }
        });
      }

      if (this.isActive === true) {
        if (expanded === 'false') {
          this.show(trigger, item, content);
        } else {
          this.hide(trigger, item, content);
        }
      }
    }
  }, {
    key: "linkClickHandlers",
    value: function linkClickHandlers() {
      var _this6 = this;

      this.triggers.forEach(function (obj) {
        obj.addEventListener('click', _this6.clickHandler.bind(_this6));
      });
    }
  }, {
    key: "bind",
    value: function bind() {
      this.linkClickHandlers();
      this.$on('resize-x', window, this.calcHeights);

      if (this.loadContainer) {
        this.$on('content-loaded', this.loadContainer, this.refreshItems);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this7 = this;

      this.triggers.forEach(function (obj) {
        obj.removeEventListener('click', _this7.clickHandler.bind(_this7));
      });
      this.$off('resize-x', window, this.calcHeights);

      if (this.loadContainer) {
        this.$off('content-loaded', this.loadContainer, this.refreshItems);
      }
    }
  }, {
    key: "isMobile",
    get: function get() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };